<div class="uw-page-container " [ngClass]="{'tw-animate-pulse': loading}">
  @if(loading) {<app-brand-loading />}
  @else if(user) {
  <div class="tw-flex tw-flex-col tw-gap-4 tw-items-center tw-py-8">
    @if(workspaceLoadFailed) {
    <mat-card role="alert"><mat-card-content>Unable to refresh workspaces. Please try again.</mat-card-content></mat-card>
    }
    @if(resellerMismatch) {
    @if(!workspaces?.length) {
    <mat-card>
      <mat-card-content>
        Access Restricted. Go to
        @if(originalReseller?.domains?.length) {
        <a class="tw-font-bold tw-text-blue-500" [href]="originalReseller!.domains![0]">{{originalReseller!.name}}</a>
        } @else {
        <a class="tw-font-bold tw-text-blue-500" [href]="voxrUrl">{{originalReseller?.name || 'Voxr AI'}}</a>
        } website to access your customer panel.
      </mat-card-content>
    </mat-card>
    }
    }
    @else {
    @if(incompleteProfile) { <app-user-profile /> }
    @else {
    @if(user.resellerConfig?.isApproved) {
    <mat-card>
      <mat-card-content>
        <div class="tw-flex tw-flex-col tw-gap-6 tw-items-center">
          To access your reseller panel, click the button below.
          @if(user.onboarded.includes('reseller-complete')) {
          @if(!user._metadata?.resellerOwner && user.resellerConfig?.whiteLabel?.domains?.length) {
          <a mat-flat-button class="btn-warning" [href]="user!.resellerConfig!.whiteLabel!.domains![0]+'/reseller'">
            @if(user.resellerConfig?.whiteLabel?.ui?.['logoUrl']) {
            <img [src]="user.resellerConfig!.whiteLabel!.ui!['logoUrl']" class="tw-max-w-5 tw-mr-2" />
            }
            Go to Reseller Panel
          </a>
          } @else {<a mat-flat-button class="btn-warning" routerLink="/reseller">Go to Reseller Panel</a>}
          } @else {<a mat-flat-button class="btn-warning" routerLink="/onboarding/reseller">Go to reseller onboarding</a>}
        </div>
      </mat-card-content>
    </mat-card>
    }
    @if(user.affiliateConfig?.isApproved) {
    <mat-card>
      <mat-card-content>
        <div class="tw-flex tw-flex-col tw-gap-6 tw-items-center">
          To access your affiliate panel, click the button below.
          <a mat-flat-button class="btn-warning" routerLink="/affiliate">Go to Affiliate Panel</a>
        </div>
      </mat-card-content>
    </mat-card>
    }

    @if(needsAccountOnboarding) {
    <mat-card>
      <mat-card-content>
        <div class="tw-flex tw-flex-col tw-gap-6 tw-items-center">
          Your {{brandName()}} account setup is not complete. Please continue the onboarding process.
          <a mat-flat-button routerLink="/account/onboarding">Continue account onboarding</a>
        </div>
      </mat-card-content>
    </mat-card>
    }

    }

    @if(workspaces?.length || user._metadata?.billing?.status == 'active'){ <app-select-workspace /> }
    }
  </div>
  }
  @else {<app-home-landing />}
</div>
